<div
  class="commercial-contractor-box-wrapper"
  [ngClass]="{
    'employer-name-requested': commercialBoxForm.get('existingOpportunity')
      ?.value
  }"
>
  <div class="contractor-heading">
    {{ 'onboarding.sellCommercial.title' | translate }}
  </div>

  <div class="contractor-desc">
    {{ 'onboarding.sellCommercial.description' | translate }}
  </div>

  <form [formGroup]="commercialBoxForm" class="commercial-box-form">
    <div class="existingOpportunity">
      <label>{{
        'onboarding.sellCommercial.exisitingOpportunity' | translate
      }}</label>

      <mat-radio-group
        aria-label="Select an option"
        formControlName="existingOpportunity"
        (change)="existingOpportunityChanged($event.value)"
      >
        <mat-radio-button [value]="true"> Yes </mat-radio-button>
        <mat-radio-button [value]="false"> No</mat-radio-button>
      </mat-radio-group>
    </div>

    <ng-container
      *ngIf="commercialBoxForm.get('existingOpportunity')?.value === true"
    >
      <div class="employerName">
        <label>{{
          'onboarding.sellCommercial.employerName' | translate
        }}</label>
        <mat-form-field appearance="outline" class="input-name">
          <input
            matInput
            formControlName="employerName"
            minlength="2"
            maxlength="200"
            required
          />
          <mat-error
            ><div
              class="input-error"
              *ngIf="commercialBoxForm?.get('employerName').touched &&
        commercialBoxForm?.get('employerName')?.errors?.['required']"
            >
              <cigna-icon
                type="exclamation-triangle"
                class="alert-icon"
              ></cigna-icon>
              {{ 'global.required' | translate }}
            </div>
            <div
              class="input-error"
              *ngIf="
              commercialBoxForm?.get('employerName')?.errors?.['minlength']
              "
            >
              <cigna-icon
                type="exclamation-triangle"
                class="alert-icon"
              ></cigna-icon>
              {{ 'forgotUsername.firstNameMinLength' | translate }}
            </div>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="eligibleEmployees">
        <label>
          {{ 'onboarding.sellCommercial.eligibleEmployees' | translate }}</label
        >
        <mat-form-field appearance="outline" class="eligible-employee-input">
          <input
            class="eligibleEmployees"
            (keypress)="numberOnly($event)"
            matInput
            required
            type="text"
            formControlName="noOfEligibleEmployees"
            min="0"
            pattern="\d*"
          />

          <mat-error
            ><div
              class="input-error"
              *ngIf="commercialBoxForm?.get('noOfEligibleEmployees')?.errors?.['required']"
            >
              <cigna-icon
                type="exclamation-triangle"
                class="alert-icon"
              ></cigna-icon>
              {{ 'global.required' | translate }}
            </div>
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>
    <div class="State">
      <label>{{ 'onboarding.sellCommercial.workState' | translate }}</label>

      <mat-form-field appearance="outline" class="input-work-state">
        <mat-select
          placeholder="Select"
          disableOptionCentering
          matInput
          [ngModel]
          state="state"
          formControlName="workingState"
          required
        >
          <mat-option [value]="'global.select' | translate" [disabled]="true">
            {{ 'global.select' | translate }}
          </mat-option>

          <mat-option *ngFor="let country of countries" [value]="country">
            {{ country }}
          </mat-option>
        </mat-select>
        <mat-error
          ><div
            class="input-error"
            *ngIf="commercialBoxForm?.get('workingState')?.errors?.['required']"
          >
            <cigna-icon
              type="exclamation-triangle"
              class="alert-icon"
            ></cigna-icon>
            {{ 'global.required' | translate }}
          </div>
        </mat-error>
      </mat-form-field>
    </div>
  </form>

  <div class="state-info">
    <label>{{ 'onboarding.sellCommercial.salesState' | translate }}</label>
  </div>

  <div class="notes">
    <label
      >{{ 'onboarding.sellCommercial.notePart1' | translate }}
      <a
        href="{{ 'onboarding.sellCommercial.noteLinkHref' | translate }}"
        target="_blank"
        >{{ 'onboarding.sellCommercial.noteLinkText' | translate }}</a
      >{{ 'onboarding.sellCommercial.notePart2' | translate }}</label
    >
  </div>

  <div class="btns">
    <button
      type="submit"
      mat-raised-button
      cg-mat-btn-type="primary"
      class="ls-button-fill"
      data-test-id="btn-submit"
      [disabled]="commercialBoxForm.invalid"
      (click)="onContinueClicked()"
    >
      {{ 'global.continue' | translate }}
    </button>
    <span
      mat-button
      class="cancel-btn"
      data-test-id="btn-cancel"
      (click)="onCancelClicked()"
    >
      {{ 'global.cancel' | translate }}
    </span>
  </div>
</div>
